// extracted by mini-css-extract-plugin
module.exports = {"discountRateContainer":"DiscountRateWrapper_discountRateContainer__hJP9t","hightlightedDiscount":"DiscountRateWrapper_hightlightedDiscount__Fsl1r"};